<template>
    <div class="site">
        <Notifications/>

        <CredentialsDialog v-if="selected_credentials" :id_account="selected_credentials.id_account" :loginname="selected_credentials.loginname" :password="selected_credentials.password" :status="selected_credentials.active" :company="selected_credentials.id_customer"/>
        <CredentialsDialog v-else-if="site" :site="site.id_site" :status="1"/>

        <div class="container-fluid">
            <Navbar/>

            <div class="row content">
                <div class="col-md-12 ml-md-auto">
                    <div class="container-inner">
                        <template v-if="site">
                            <div class="container-header">
                                <div class="row">
                                    <div class="col col-auto">
                                        <h2>
                                            <span v-if="site.active_sections == 0" class="text-danger">[Inactive]</span>
                                            Site: {{ site.sitename }}
                                            <sup class="subtitle">id_site: {{ site.id_site }}</sup>
                                        </h2>
                                        <h4 class="subtitle" v-if="accounts.length > 0">Total credentials: {{ accounts.length }}</h4>
                                    </div>
                                    <div class="col credentials-col">
                                        <button @click="selected_credentials = null" type="button" class="btn btn-success" data-toggle="modal" data-target="#credentials-dialog">Add credentials</button>
                                    </div>
                                </div>

                            </div>
                            <div class="container-content">
                                <table class="table table-striped table-bordered table-hover table-md-responsive">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>id_account</th>
                                            <th>Login name</th>
                                            <th>Password</th>
                                            <th>Created</th>
                                            <th>End date</th>
                                            <th>Company</th>
                                            <th>Status</th>
                                            <th>Success count</th>
                                            <th>Fail count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="a in accounts" v-bind:key="a.id_account">
                                            <td>
                                                <span class="link" @click="selected_credentials = a" data-toggle="modal" data-target="#credentials-dialog">{{ a.id_account }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.loginname }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.password }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.start_date|formatDate }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.end_date|formatDate }}</span>
                                            </td>
                                            <td class="split">
                                                <router-link v-if="a.id_customer" class="link" :to="{ name: 'company', params: { id_customer: a.id_customer }}">
                                                {{ a.company_name }}

                                                <sup>{{ a.id_customer }}</sup>
                                            </router-link>
                                            </td>
                                            <td>
                                                <span>{{ a.active|formatStatus }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.login_success }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.login_fail }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <template v-else-if="error">
                            An error occurred while loading site accounts. Is the id in the URL correct?
                        </template>
                        <template v-else>
                            Loading...
                        </template>
                    </div>
                </div>
            </div>

            <div class="row content" v-if="site">
                <div class="col-md-12 ml-md-auto">
                    <div class="container-inner">
                        <div class="container-header">
                            <div class="row">
                                <div class="col-auto">
                                    <div class="custom-control custom-switch" title="Toggle view">
                                        <input type="checkbox" class="custom-control-input" v-model="logMode" id="toggle-site-mode-btn">
                                        <label class="custom-control-label" for="toggle-site-mode-btn"></label>
                                    </div>
                                </div>
                                <div class="col">
                                    <h2>{{ modeTitle }}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="container-content">
                            <div v-if="loadingArticles" class="spinner-container"><div class="spinner-border" role="status"></div></div>
                            <div v-else-if="errorMsg" class="error">{{ errorMsg }}</div>
                            <template v-else-if="articles && Object.keys(articles).length">
                                <table class="table table-striped table-bordered table-hover table-md-responsive">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>id_account</th>
                                            <th>Article header</th>
                                            <th>Paywall flag</th>
                                            <th>Link</th>
                                            <th @click="sort = 'id_event'" class="sortable" :class="{ active: sort == 'id_event' }">Event</th>
                                            <th @click="sort = 'timestamp'" class="sortable" :class="{ active: sort == 'timestamp' }">Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="article in articles" :key="article.id">
                                            <td>
                                                <span class="link" @click="selected_credentials = article" data-toggle="modal" data-target="#credentials-dialog">{{ article.id_account }}</span>
                                            </td>
                                            <td>
                                                <span :title="article.header">{{ article.header|ellipsize(80) }}</span>
                                            </td>
                                            <td>
                                                <span v-if="'paywall_flag' in article">{{ article.paywall_flag == 32 ? 'Yes' : 'No' }}</span>
                                            </td>
                                            <td>
                                                <a v-if="article.id_link" :href="'http://tools.opoint.com/AI/art_info.php?id_link=' + article.id_link" target="_blank">/AI/art_info.php?id_link={{ article.id_link }}</a>
                                                <a v-else-if="article.id_link == 0 && article.id_source" :href="'http://tools.opoint.com/OLE/?id_source=' + article.id_source" target="_blank">/OLE/?id_source={{ article.id_source }}</a>
                                            </td>
                                            <td>{{ article.event_text }}</td>
                                            <td>{{ article.timestamp|formatDate }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="loadingMore" class="spinner-container"><div class="spinner-border" role="status"></div></div>
                                <button v-else @click="loadMore" class="btn btn-primary load-more">Load more</button>
                            </template>
                            <template v-else>
                                <div class="error">No results</div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notifications from '@/components/Notifications'
import Navbar from '@/components/Navbar'
import CredentialsDialog from '@/components/CredentialsDialog'

import { NAME_ACRONYM } from '@/constants'

export default {
    name: 'Site',
    data() {
        return {
            selected_credentials: null,
            id_site: null,
            loadingArticles: false,
            loadingMore: false,
            page: 1,
            sort: 'timestamp',
            errorMsg: null,
            logMode: false // True: Log mode (each row is one login attempt), False: Article mode
        }
    },
    watch: {
        '$route.params.id_site': {
            immediate: true,
            handler(val) {
                this.id_site = val
            }
        },
        logMode(val) {
            if (val) {
                this.page = 1
                this.fetchLogs()
            } else {
                this.page = 1
                this.fetchArticles()
            }
        },
        id_site: {
            immediate: true,
            handler(val) {
                this.$store.dispatch('fetchSite', val)
                this.fetchArticles()
            }
        },
        site(val) {
            document.title = val.sitename + " :: " + NAME_ACRONYM
        }
    },
    methods: {
        fetchArticles() {
            this.loadingArticles = true
            this.$store.dispatch('fetchArticles', {id_site: this.id_site, page: this.page})
            .then(() => {
                this.errorMsg = null
            }).catch(error => {
                this.errorMsg = error
            }).then(() => {
                this.loadingArticles = false
            })
        },
        fetchLogs() {
            this.loadingArticles = true
            this.$store.dispatch('fetchLogs', {id_site: this.id_site, page: this.page})
            .then(() => {
                this.errorMsg = null
            }).catch(error => {
                this.error = error
            }).then(() => {
                this.loadingArticles = false
            })
        },
        loadMore() {
            this.loadingMore = true

            this.page++

            if (this.logMode) {
                this.$store.dispatch('fetchLogs', {id_site: this.id_site, page: this.page})
                .then(() => {
                    this.errorMsg = null
                }).catch(error => {
                    this.error = error
                }).then(() => {
                    this.loadingMore = false
                })
            } else {
                this.$store.dispatch('fetchArticles', {id_site: this.id_site, page: this.page})
                .then(() => {
                    this.errorMsg = null
                }).catch(error => {
                    this.error = error
                }).then(() => {
                    this.loadingMore = false
                })
            }

        }
    },
    components: {
        Notifications, Navbar, CredentialsDialog
    },
    computed: {
        modeTitle() {
            return this.logMode ? 'Latest login attempts' : 'Latest articles'
        },
        error: function() {
            return this.$store.state.error
        },
        site: function() {
            return this.$store.state.site
        },
        accounts: function() {
            return this.$store.state.accounts
        },
        articles: function() {
            let articles = (this.logMode ? this.$store.state.logs : this.$store.state.articles)

            let sortable = []
            for (let a in articles) {
                sortable.push([a, articles[a][this.sort]])
            }

            sortable = sortable.sort((a, b) => {
                return b[1] - a[1]
            })

            let final = {}

            for (let i = 0; i < sortable.length; i++) {
                const a = articles[sortable[i][0]]

                final[i] = a
            }

            return final
        }
    }
}
</script>

<style scoped lang="sass">
@import '@/styles/_variables.sass'

.col, .col-auto
    align-self: center

a:visited
    color: #602080

.load-more
    margin: 20px auto 0
    display: block

.site
    height: 100%
    position: relative

    .sortable
        cursor: pointer

        &.active
            font-weight: bold

    .status-th
        min-width: 100px

    .subtitle
        color: $gray
        font-size: $font-size
        font-weight: 400
        margin: 8px 0 0

    .link
        color: $gray
        cursor: pointer
        text-decoration: none

        &:hover
            color: $black

    .dialog-container
        position: fixed
        top: 0
        left: 0
        width: 100%
        height: 100%
        z-index: 1000
        background: rgba(0,0,0,0.6)

        .help p
            margin-bottom: 10px

        .gnip-query-input
            width: 100%
            margin-top: 8px

        .dialog-box
            background: white
            border-radius: 3px
            position: absolute
            left: 50%
            top: 50%
            max-width: 80%
            max-height: 95%
            transform: translate(-50%, -50%)
            overflow: auto

            .dialog-box-inner
                padding: 40px

    .small-text
        font-size: $font-size-small

    .container
        margin-left: $sidebar-width
        height: 100%
        position: relative
        display: flex
        flex-direction: column

        .container-header
            padding: 30px
            text-align: left

            h1
                margin: 0
                font-size: $font-size-bigger

        .container-content
            padding: 10px 20px

        .container-inner
            flex-grow: 1
            overflow: auto

</style>
